import { Component, Output, EventEmitter, ViewChild, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QaiDialogComponent } from '@qai/ui';
import { PracticeUsersComponent } from '../../../dashboard-tabs/assignments-tab/practice-tab/practice-detail/practice-users/practice-users.component';
import { IUserPracticeDetail } from 'src/app/interfaces/reportingV2/iuser-practice-details';

@Component({
  selector: 'app-practice-assignment-user-modal',
  standalone: true,
  imports: [CommonModule, QaiDialogComponent, PracticeUsersComponent],
  templateUrl: './practice-assignment-user-modal.component.html',
  styleUrls: ['./practice-assignment-user-modal.component.scss']
})
export class PracticeAssignmentUserModalComponent implements OnChanges{

  @ViewChild('practiceUsersDialog') qaiDialogRef: QaiDialogComponent | undefined;
  @Input() openUserModal = false;
  @Input() moduleAssignmentUuid: string = '';
  @Input() teamUuids: string[] = [];
  @Input() engagementStatus: string | null = null;
  @Input() userData: IUserPracticeDetail[] = [];
  @Input() isLoadingData: boolean = false;
  @Input() assignmentName: string = '';
  @Output() closeUserModal = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['openUserModal'] && this.qaiDialogRef) {
      this.openUserModal
        ? this.qaiDialogRef.showModal()
        : this.qaiDialogRef.close();
    }
  }

  handleCloseModal(): void {
    this.qaiDialogRef?.close();
    this.closeUserModal.emit();
  }
}
